"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var PlayerLevelOffersListCtl = /** @class */ (function (_super) {
    __extends(PlayerLevelOffersListCtl, _super);
    function PlayerLevelOffersListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_app_language_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_id; });
        _this.dk_app_language_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_title; });
        _this.dk_offer_text = UIUtils_1.UIUtils.IProp2Str(function (o) { o.offer_text; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_priority = UIUtils_1.UIUtils.IProp2Str(function (o) { o.priority; });
        _this._errDialog = errDialog;
        return _this;
    }
    PlayerLevelOffersListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    PlayerLevelOffersListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "player level title with id [" + id + "] not found !";
    };
    PlayerLevelOffersListCtl.prototype.LoadData = function (LevelId, onDone) {
        var _this = this;
        webAApi_1.ListBonusPlayerLevelOffersByLevelIdGet.exec({
            bonus_player_level_id: LevelId
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    offer_text: resp.list[i].offer_text,
                    app_language_id: resp.list[i].app_language_id,
                    app_language_title: resp.list[i].app_language_title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    title: resp.list[i].title,
                    is_locked: resp.list[i].is_locked,
                    priority: resp.list[i].priority
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerLevelOffersListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBonusPlayerLevelOffer.exec({
            data: {
                offer_text: data.offer_text,
                app_language_id: data.app_language_id,
                brand_bonus_level_id: data.brand_bonus_level_id,
                title: data.title,
                is_locked: data.is_locked,
                priority: data.priority
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed: moment(resp.date_changed_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                app_language_id: data.app_language_id,
                app_language_title: resp.app_language_title,
                offer_text: data.offer_text,
                title: data.title,
                is_locked: data.is_locked,
                priority: data.priority
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerLevelOffersListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBonusPlayerLevelOffer.exec({
                data: {
                    brands_player_level_offer_id: data.key,
                    offer_text: data.offer_text,
                    app_language_id: data.app_language_id,
                    title: data.title,
                    is_locked: data.is_locked,
                    priority: data.priority
                }
            }, function (resp) {
                _tmp.offer_text = data.offer_text;
                _tmp.title = data.title;
                _tmp.app_language_id = data.app_language_id;
                _tmp.app_language_title = resp.app_language_title;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.is_locked = data.is_locked;
                _tmp.priority = data.priority;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PlayerLevelOffersListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    PlayerLevelOffersListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBonusPlayerLevelOffer.exec({
                data: {
                    brands_player_level_offer_id: key
                }
            }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PlayerLevelOffersListCtl.prototype.SetIsLocked = function (key, IsLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBonusPlayerLevelOfferIsLocked.exec({
                data: {
                    player_level_offer_id: key,
                    is_locked: IsLocked
                }
            }, function (resp) {
                _tmp.is_locked = IsLocked;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PlayerLevelOffersListCtl.prototype.SetPriority = function (key, Priority, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBonusPlayerLevelOfferPriority.exec({
                data: {
                    player_level_offer_id: key,
                    priority: Priority
                }
            }, function (resp) {
                _tmp.priority = Priority;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return PlayerLevelOffersListCtl;
}(BaseController_1.BaseController));
exports.PlayerLevelOffersListCtl = PlayerLevelOffersListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_player_levels/ctl/PlayerLevelOffersListCtl.ts
// module id = 985
// module chunks = 0